module.exports = __webpack_public_path__ + "static/media/Jerry B Mathew .821f4714.jpg";